import HeaderNavigation from './HeaderNavigation.component';

export default HeaderNavigation;